import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class CardVerificationSample extends Component {
    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    renderDOTNET() {
        const { storeId, apiToken, pan, expdate } = this.props;

        return (
            <pre className="sampleCode">
{`namespace Moneris
{
 using System;

 public class TestCanadaCardVerficiation
 { 
  public static void Main(string[] args)
  { 
   string store_id = "`}{this.getValue(storeId, "storeId")}{`";
   string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
   string order_id = "Test" + DateTime.Now.ToString("yyyyMMddhhmmss");
   string pan = "`}{this.getValue(pan, "pan")}{`";
   string expdate = "`}{this.getValue(expdate, "expdate")}{`"; //YYMM format
   string crypt = "7";
   string processing_country_code = "CA";
   bool status_check = false;

   AvsInfo avsCheck = new AvsInfo();

   avsCheck.SetAvsStreetNumber("212");
   avsCheck.SetAvsStreetName("Payton Street");
   avsCheck.SetAvsZipCode("M1M1M1");

   CvdInfo cvdCheck = new CvdInfo();

   cvdCheck.SetCvdIndicator("1");
   cvdCheck.SetCvdValue("099");
   CofInfo cof = new CofInfo();
   cof.SetPaymentIndicator("U");
   cof.SetPaymentInformation("2");
   cof.SetIssuerId("12345678901234");

   CardVerification cardVerification = new CardVerification();

   cardVerification.SetOrderId(order_id);
   cardVerification.SetPan(pan);
   cardVerification.SetExpDate(expdate);
   cardVerification.SetCryptType(crypt);
   cardVerification.SetAvsInfo(avsCheck);
   cardVerification.SetCvdInfo(cvdCheck);
   cardVerification.SetCofInfo(cof);

   HttpsPostRequest mpgReq = new HttpsPostRequest();

   mpgReq.SetProcCountryCode(processing_country_code);
   mpgReq.SetTestMode(true); //false or comment out this line for production transactions
   mpgReq.SetStoreId(store_id);
   mpgReq.SetApiToken(api_token);
   mpgReq.SetTransaction(cardVerification);
   mpgReq.SetStatusCheck(status_check);
   mpgReq.Send();

   try
   { 
    Receipt receipt = mpgReq.GetReceipt();
    Console.WriteLine("CardType = " + receipt.GetCardType());
    Console.WriteLine("TransAmount = " + receipt.GetTransAmount());
    Console.WriteLine("TxnNumber = " + receipt.GetTxnNumber());
    Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
    Console.WriteLine("TransType = " + receipt.GetTransType());
    Console.WriteLine("ReferenceNum = " + receipt.GetReferenceNum());
    Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
    Console.WriteLine("ISO = " + receipt.GetISO());
    Console.WriteLine("BankTotals = " + receipt.GetBankTotals());
    Console.WriteLine("Message = " + receipt.GetMessage());
    Console.WriteLine("AuthCode = " + receipt.GetAuthCode());
    Console.WriteLine("Complete = " + receipt.GetComplete());
    Console.WriteLine("TransDate = " + receipt.GetTransDate());
    Console.WriteLine("TransTime = " + receipt.GetTransTime());
    Console.WriteLine("Ticket = " + receipt.GetTicket());
    Console.WriteLine("TimedOut = " + receipt.GetTimedOut());
    Console.WriteLine("IsVisaDebit = " + receipt.GetIsVisaDebit());
    Console.WriteLine("IssuerId = " + receipt.GetIssuerId());
    Console.ReadLine();
   } 
   catch (Exception e)
   { 
    Console.WriteLine(e);
   }
  }
 }
}
`}
            </pre>
        )
    }

    renderJAVA() {
        const { storeId, apiToken, pan, expdate } = this.props;

        return (
            <pre className="sampleCode">
{`package Canada;

import JavaAPI.*;

public class TestCanadaCardVerification
{ 
 public static void main(String[] args)
 { 
  String store_id = "`}{this.getValue(storeId, "storeId")}{`";
  String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
  java.util.Date createDate = new java.util.Date();
  String order_id = "Test"+createDate.getTime();
  String pan = "`}{this.getValue(pan, "pan")}{`";
  String expdate = "`}{this.getValue(expdate, "expdate")}{`"; //YYMM format
  String crypt = "7";
  String processing_country_code = "CA";
  boolean status_check = false;

  AvsInfo avsCheck = new AvsInfo();
  
  avsCheck.setAvsStreetNumber("212");
  avsCheck.setAvsStreetName("Payton Street");
  avsCheck.setAvsZipCode("M1M1M1");

  CvdInfo cvdCheck = new CvdInfo();

  cvdCheck.setCvdIndicator("1");
  cvdCheck.setCvdValue("099");
  CardVerification cardVerification = new CardVerification();
  cardVerification.setOrderId(order_id);
  cardVerification.setPan(pan);
  cardVerification.setExpdate(expdate);
  cardVerification.setCryptType(crypt);
  cardVerification.setAvsInfo(avsCheck);
  cardVerification.setCvdInfo(cvdCheck);
  //optional - Credential on File details

  CofInfo cof = new CofInfo();

  cof.setPaymentIndicator("U");
  cof.setPaymentInformation("2");
  cof.setIssuerId("139X3130ASCXAS9");
  cardVerification.setCofInfo(cof);

  HttpsPostRequest mpgReq = new HttpsPostRequest();

  mpgReq.setProcCountryCode(processing_country_code);
  mpgReq.setTestMode(true); //false or comment out this line for production transactions
  mpgReq.setStoreId(store_id);
  mpgReq.setApiToken(api_token);
  mpgReq.setTransaction(cardVerification);
  mpgReq.setStatusCheck(status_check);
  mpgReq.send();

  try
  { 
   Receipt receipt = mpgReq.getReceipt();
   System.out.println("CardType = " + receipt.getCardType());
   System.out.println("TransAmount = " + receipt.getTransAmount());
   System.out.println("TxnNumber = " + receipt.getTxnNumber());
   System.out.println("ReceiptId = " + receipt.getReceiptId());
   System.out.println("TransType = " + receipt.getTransType());
   System.out.println("ReferenceNum = " + receipt.getReferenceNum());
   System.out.println("ResponseCode = " + receipt.getResponseCode());
   System.out.println("ISO = " + receipt.getISO());
   System.out.println("BankTotals = " + receipt.getBankTotals());
   System.out.println("Message = " + receipt.getMessage());
   System.out.println("AuthCode = " + receipt.getAuthCode());
   System.out.println("Complete = " + receipt.getComplete());
   System.out.println("TransDate = " + receipt.getTransDate());
   System.out.println("TransTime = " + receipt.getTransTime());
   System.out.println("Ticket = " + receipt.getTicket());
   System.out.println("TimedOut = " + receipt.getTimedOut());
   System.out.println("IsVisaDebit = " + receipt.getIsVisaDebit());
   System.out.println("IssuerId = " + receipt.getIssuerId());
  } 
  catch (Exception e)
  { 
   e.printStackTrace();
  }
 }
}
`}
            </pre>
        )
    }

    renderPHP() {
        const { storeId, apiToken, pan, expdate } = this.props;

        return (
            <pre className="sampleCode">
{`<?php

require "../../mpgClasses.php";

$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token="`}{this.getValue(apiToken, "apiToken")}{`";
$txnArray=array('type'=>'card_verification',
'order_id'=>'ord-'.date("dmy-G:i:s"),
'cust_id'=>'my cust id',
'pan'=>'`}{this.getValue(pan, "pan")}{`',
'expdate'=>'`}{this.getValue(expdate, "expdate")}{`',
'crypt_type'=>'7'
);

$mpgTxn = new mpgTransaction($txnArray);

/************************** AVS Variables *****************************/
$avs_street_number = '201';
$avs_street_name = 'Michigan Ave';
$avs_zipcode = 'M1M1M1';

/************************** CVD Variables *****************************/
$cvd_indicator = '1';
$cvd_value = '198';

/********************** AVS Associative Array *************************/
$avsTemplate = array(
'avs_street_number'=>$avs_street_number,
'avs_street_name' =>$avs_street_name,
'avs_zipcode' => $avs_zipcode
);

/********************** CVD Associative Array *************************/
$cvdTemplate = array(
'cvd_indicator' => $cvd_indicator,
'cvd_value' => $cvd_value
);

/************************** AVS Object ********************************/
$mpgAvsInfo = new mpgAvsInfo ($avsTemplate);

/************************** CVD Object ********************************/
$mpgCvdInfo = new mpgCvdInfo ($cvdTemplate);

/*********************** Credential on File ************************/
$cof = new CofInfo();
$cof->setPaymentIndicator("U");
$cof->setPaymentInformation("2");
$cof->setIssuerId("12345678901234");
$mpgTxn->setAvsInfo($mpgAvsInfo);
$mpgTxn->setCvdInfo($mpgCvdInfo);
$mpgTxn->setCofInfo($cof);
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions
$mpgHttpPost =new mpgHttpsPost($store_id,$api_token,$mpgRequest);
$mpgResponse=$mpgHttpPost->getMpgResponse();
print("\\nCardType = " . $mpgResponse->getCardType());
print("\\nTransAmount = " . $mpgResponse->getTransAmount());
print("\\nTxnNumber = " . $mpgResponse->getTxnNumber());
print("\\nReceiptId = " . $mpgResponse->getReceiptId());
print("\\nTransType = " . $mpgResponse->getTransType());
print("\\nReferenceNum = " . $mpgResponse->getReferenceNum());
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nISO = " . $mpgResponse->getISO());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nIsVisaDebit = " . $mpgResponse->getIsVisaDebit());
print("\\nAuthCode = " . $mpgResponse->getAuthCode());
print("\\nComplete = " . $mpgResponse->getComplete());
print("\\nTransDate = " . $mpgResponse->getTransDate());
print("\\nTransTime = " . $mpgResponse->getTransTime());
print("\\nTicket = " . $mpgResponse->getTicket());
print("\\nTimedOut = " . $mpgResponse->getTimedOut());
print("\\nIssuerId = " . $mpgResponse->getIssuerId());
?>
`}
            </pre>
        )
    }

    render() {
        switch(this.props.progLangId) {
            case _DOTNET: 
                return this.renderDOTNET()
            case _JAVA:
                return this.renderJAVA()
            case _PHP:
                return this.renderPHP()

            default:
                return null
        }
        
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, orderId, pan, expdate, onEditId } = state.transactions.main.config;
    const { selection } = state.common.progLangList;
    return { storeId, apiToken, orderId, pan, expdate, onEditId, progLangId: selection };
  }
  
  export default connect(mapStateToProps, {})(CardVerificationSample)